import { PlusIcon } from '@shopify/polaris-icons';
import { TextField } from '../components/forms';
import { useRef, useState } from 'react';
import { Banner, BlockStack, Button, Card, Text } from '@shopify/polaris';
import { useApi } from '../hooks/useApi';
export default function CreateTestSpace() {
  const { fetchApi, error } = useApi();
  const [name,setName] = useState('');
  const [busy,setBusy] = useState(false);
  const [result,setResult] = useState<{slug:string;name:string}|null>(null);
  const attempt=useRef<{name:string;request_id:string}|null>(null);
  const create=async()=>{
    if(busy)return;setBusy(true);
    attempt.current ||= {name:name.trim(),request_id:crypto.randomUUID()};
    const response=await fetchApi<{success:boolean;organization:{slug:string;name:string}}>('/api/organizations',{method:'POST',body:JSON.stringify(attempt.current)});
    if(response?.success)setResult(response.organization);
    setBusy(false);
  };
  return <Card><BlockStack gap="300"><Text as="h2" variant="headingMd">Create a free test company</Text>
    <Text as="p">Creates an empty company on the free plan. No card, paid subscription, copied company data or extra login is created. You can add a warehouse account and invite the tester from its Settings page.</Text>
    {error&&<Banner tone="critical">{error} Retry to check the same company request.</Banner>}
    {result?<Banner tone="success">{result.name} is ready. <a href={`https://${result.slug}.whenlyapp.com/settings`}>Open its Settings</a> to create the warehouse account and send the tester’s invitation.</Banner>:<>
      <TextField label="Test company name" requiredIndicator value={name} onChange={setName} disabled={busy||!!attempt.current} autoComplete="off"/>
      <Button icon={attempt.current ? undefined : PlusIcon} variant="primary" onClick={create} loading={busy} disabled={name.trim().length<2}>{attempt.current?'Retry company creation':'Create free test company'}</Button>
    </>}
  </BlockStack></Card>;
}
